// src/pages/micuenta/Curriculum.jsx
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { FaArrowLeft, FaFile } from "react-icons/fa";
import "./curriculum.css";

function Curriculum() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  if (!user) {
    return (
      <div className="register-container">
        <div className="register-card">
          <h2 className="register-title">Cargando usuario...</h2>
        </div>
      </div>
    );
  }

  // Estado para el CV actual y el archivo seleccionado
  const [currentCV, setCurrentCV] = useState("MiCurriculum.pdf");
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleUpload = () => {
    if (!selectedFile) {
      alert("Primero selecciona un archivo");
      return;
    }
    // Aquí podrías conectar con tu API de subida
    setCurrentCV(selectedFile.name);
    alert(`Currículum "${selectedFile.name}" subido correctamente`);
    setSelectedFile(null);
  };

  const handleUpdate = () => {
    alert("Opción de actualizar el CV existente (simulación).");
  };

  const handleDownload = () => {
    alert(`Descargando el currículum: ${currentCV}`);
  };

  return (
    <div className="register-container">
      <div className="register-card">
        {/* Botón para regresar a Mi Cuenta */}
        <button className="back-button" onClick={() => navigate("/mi-cuenta")}>
          <FaArrowLeft className="back-icon" /> Regresar a Mi Cuenta
        </button>

        {/* Sección de Curriculum Vitae */}
        <h2 className="curriculum-title">
          <FaFile className="section-icon" /> Curriculum Vitae
        </h2>
        <p className="curriculum-subtext">
          Documentos permitidos: <strong>.PDF, .JPG, .PNG</strong>
        </p>

        <div className="curriculum-upload-section">
          <input
            type="file"
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={handleFileChange}
            className="curriculum-file-input"
          />
          <button className="curriculum-upload-btn" onClick={handleUpload}>
            Subir Curriculum
          </button>
        </div>

        {/* Información del currículum actual */}
        <div className="curriculum-info">
          <p>
            <strong>Currículum:</strong> {currentCV}
          </p>
          <div className="curriculum-actions">
            <button className="curriculum-action-btn" onClick={handleUpdate}>
              Actualizar
            </button>
            <button className="curriculum-action-btn" onClick={handleDownload}>
              Descargar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Curriculum;